module.exports = __webpack_public_path__ + "img/microsoft-mcsa.d5fe4ed0.png";